import { getFeatureFlag } from "src/api/featureFlags";
import { Role, User } from "../../auth/types/interfaces";
import { forbiddenResponse, successResponse } from "../constants";

export const loader = async (user: User) => {
  /**
   * Loader function for IPL pages
   *
   * @returns {Promise<Response>} A Promise that resolves with a Response object.
   *   Returns OK if user has IPL role and IPL claims feature is enabled
   *   Returns 404 not found if user doesn't have role or feature is disabled
   */
  const isIplEnabled = await getFeatureFlag("enableIplClaims");

  if (isIplEnabled && user.roles.includes(Role.IPL_CLAIM_USER)) {
    return successResponse();
  } else {
    throw forbiddenResponse();
  }
};
